import Vue from 'vue'
import App from './App.vue'
import VTooltip from 'v-tooltip'
import 'element-ui/lib/theme-chalk/index.css';
import { library } from '@fortawesome/fontawesome-svg-core'
import { faPlusSquare, faCopy, faExternalLinkAlt, faHourglass, faHandPointRight, faCheckCircle, faAngleRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faPlusSquare, faCopy, faExternalLinkAlt, faHourglass, faHandPointRight, faCheckCircle, faAngleRight);

import ElementUI from 'element-ui';
import itLocale from 'element-ui/lib/locale/lang/it';
import 'element-ui/lib/theme-chalk/index.css';
import { vuexStore } from './store';
import _ from 'lodash';

Vue.use(ElementUI, { itLocale });
Vue.use(VTooltip);
Vue.component('font-awesome-icon', FontAwesomeIcon);

new Vue({
  render: h => h(App),
  store: vuexStore
}).$mount('#app');